// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { addToChainAfter, addToChainBefore, replaceInChain } from "@insite/client-framework/HandlerCreator";
import {
    chain,
    SendTracking,
    SetDisplayTitles,
} from "@insite/client-framework/Store/CommonHandlers/GetAutocompleteModel";
import { xGoogleAnalyticsState } from "@west/App/Store/Reducers";
import { googleAnalyticsSearchTracking } from "@west/XDL/Utilities/tracking";

export const XngSendTracking: typeof SetDisplayTitles = props => {
    if (props.apiResult?.products?.length === 1) {
        googleAnalyticsSearchTracking(
            (props.getState() as xGoogleAnalyticsState).xGoogleAnalytics,
            props.apiParameter.query,
            1,
        );
    }
};

replaceInChain(chain, SendTracking, XngSendTracking);
